import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const WalletContainer = styled.div``;

export const HeaderLoader = styled(ContentLoader)`
  height: 3.2rem;
  width: 100%;

  ${({ theme }) => theme.media.laptop`
    height: 4.7rem;
  `};
`;

export const HeaderLine = styled.rect`
  height: 0.1rem;
  width: 100%;

  y: 3.1rem;
  ${({ theme }) => theme.media.laptop`
    y: 4.6rem;
  `};
`;

export const Asset = styled.rect`
  width: 7rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 0.6rem;

  ${({ theme }) => theme.media.mobileL`
    x: 1.6rem;
  `};

  ${({ theme }) => theme.media.laptop`
    y: 1.35rem;
    x: 2.4rem;
  `};
`;

export const Amount = styled.rect`
  width: 7rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 0.6rem;
  x: 40%;
  ${({ theme }) => theme.media.laptop`
    y: 1.35rem;
    x: 29%;
  `};
`;
export const Value = styled.rect`
  display: none;

  width: 7rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 0.6rem;

  ${({ theme }) => theme.media.laptop`
    display:initial;
    y: 1.35rem;
    x: 51%;

    width: 9rem;
  `};
`;

export const Price = styled.rect`
  width: 7rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 0.6rem;

  x: calc(100% - 7rem);

  ${({ theme }) => theme.media.mobileL`
      x: 70%;
  `};

  ${({ theme }) => theme.media.laptop`
    y: 1.35rem;
    x: 75%;
  `};
`;

export const BodyLoaderWrapper = styled(ContentLoader)`
  height: 6.1rem;
  width: 100%;
`;

export const BodyLine = styled.rect`
  height: 0.1rem;
  width: 100%;

  y: 6rem;
`;

export const AssetIcon = styled.circle`
  cx: 2.4rem;
  cy: 3rem;

  r: 1.9rem;

  ${({ theme }) => theme.media.mobileL`
      cx: 3.5rem;
  `};
`;
export const AssetName = styled.rect`
  height: 1.8rem;
  width: 7rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 1rem;
  x: 5.3rem;

  ${({ theme }) => theme.media.mobileL`
      x: 6.4rem;
  `};
`;

export const AssetCode = styled.rect`
  height: 1.8rem;
  width: 3rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 3rem;
  x: 5.3rem;

  ${({ theme }) => theme.media.mobileL`
      x: 6.4rem;
  `};
`;

export const AmountInUsd = styled.rect`
  height: 1.8rem;
  width: 6rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 1rem;
  x: 40%;

  ${({ theme }) => theme.media.laptop`
      display: none;
  `};
`;

export const AssetAmount = styled.rect`
  height: 1.8rem;
  width: 8rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 3rem;
  x: 40%;

  ${({ theme }) => theme.media.laptop`
      height: 2rem;
      
      y: 1.8rem;
      x: 29%;
  `};
`;

export const AssetValue = styled.rect`
  display: none;

  width: 8rem;
  height: 2rem;

  x: 51%;
  y: 1.8rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop`
      display: initial;
  `};
`;

export const AssetPrice = styled.rect`
  width: 9rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 1.8rem;
  x: calc(100% - 9rem);

  ${({ theme }) => theme.media.mobileL`
      x: 70%;
  `};

  ${({ theme }) => theme.media.laptop`
    x: 75%;
  `};
`;
